module.exports = __webpack_public_path__ + "img/79b41d54-500a-4304-bbff-58d1677c036c.6bcdb290.gif";